export const BOT_SERVER_URL = "https://tg.gm-cloud.ru"
//export const BOT_SERVER_URL = "https://bot.claris.su"
